<div *ngIf="displayData"
     class="results-table table-container"
     #tableBody>
  <table mat-table
         [dataSource]="displayData" multiTemplateDataRows
         class="mat-elevation-z8">
    <ng-container matColumnDef="{{column}}" *ngFor="let column of headersToDisplay, let i = index"
                  [sticky]="i === 0"
    >
      <th mat-header-cell *matHeaderCellDef
      > {{ firstColumnHeader && i === 0 ? firstColumnHeader : (column === nameString || column === labelString ? '' : column)}} </th>
      <td mat-cell *matCellDef="let element"
          [ngClass]="{'category': categories.includes(element[nameString]) && !element['isChild'] || element['onlyChild'],
          'clickable': !element['isChild'] && !element['onlyChild'] && !element['isSection'],
          'section': element['isSection'],
          'name': column === nameString || column === labelString
          }"
      >
        <span [innerHTML]="formatDecimalPlaces(element[column])"></span>
        <mat-icon class="mat-icon-rtl-mirror"
                  *ngIf="shouldShowExpandIcon(column, element)"
                  style="vertical-align: middle;">
          {{expandedCategories.includes(element['name']) ? 'expand_less' : 'expand_more'}}
        </mat-icon>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="headersToDisplay; sticky: true"></tr>
    <tr mat-row *matRowDef="let element; columns: headersToDisplay;"
        (click)="onTableClick(element)"
    >
    </tr>
  </table>
</div>
<div class="results-container media-button-container">
  <button
    mat-button
    class="btn-green save-media-button"
    (click)="openSaveDialog(false)"
  >{{'RESULTS.GENERAL.SAVE_CSV_FILE_TO_PC' | anessaTranslation: trigger}}
  </button>
</div>
